import {visibilityFilter} from '../../utils/VisibilityFilter';
import {RootState} from '../../store';
import {DomainName} from "./types.ts";

const key = 'domainNames';

// FNP-942: records moved to React Query. What remains in Redux for this module
// is SELECTION (the checkbox set) and VISIBILITY (page, limit, keyword, columns).
//
// ⚠️ These selectors deliberately no longer read `state.domainNames.records`.
// The old `visibilitySelector` derived `totalCount`/`items` from the records
// slice; leaving that in place while the slice is unpopulated computes paging
// from an empty set, which is a live defect in flexi-email-app today (FNP-950).
// Paging is now derived from the items React Query supplies, passed in.

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilityStateSelector = (state: RootState) => {
    return state[key].visibility;
};

/**
 * Derives the paged/filtered view from records React Query already fetched.
 *
 * Takes `items` as an argument rather than reading them from the store — the
 * store no longer holds records. Callers pass what `useDomainNamesQuery`
 * returned.
 */
export const selectVisibility = (
    visibility: {
        page: number,
        limit: number,
        keyword: string,
        visible: boolean,
        columns: string[]
    },
    items: DomainName[],
    registrarId?: string,
) => {
    const scoped = typeof registrarId !== 'undefined' && registrarId !== ''
        ? items.filter((item: DomainName) => item.registrarId === registrarId)
        : items;

    const {
        page,
        limit,
        keyword,
        visible,
        columns
    } = visibility;

    const visibleItems = visibilityFilter(scoped, page, limit, keyword);

    // Count against the real fetched set — not a slice that is never populated.
    const visibleCount = keyword ? visibleItems.length : scoped.length;

    const totalPages = Math.ceil(visibleCount / limit);

    return {
        items: scoped,
        visibleItems,
        page,
        limit,
        keyword,
        visible,
        columns,
        visibleCount,
        totalPages,
    };
};
